import React from 'react'
import { Stack, Typography } from '@mui/material'
import { DoctorPatientProfile } from '../../types/doctorPatients.types'
import { useTranslation } from '../../../../../common/hooks'
import { formatAddress } from '../../../../../utils/formatAddress'
import { SendMessageToPatientButton } from '../SendMessageToPatientButton'
import { BoxWithLabel } from '../../../../../common/components'

interface PatientContactDataProps {
  patientProfile: DoctorPatientProfile
}

export const PatientContactDataSection: React.FC<
  React.PropsWithChildren<PatientContactDataProps>
> = ({ patientProfile }) => {
  const { t } = useTranslation()

  return (
    <Stack>
      <Typography variant="body2" fontWeight="700">
        {t('patients:contactDataLabel')}
      </Typography>

      <BoxWithLabel size="small" label={t('patients:email')}>
        <Typography variant="body2">{patientProfile.user?.email}</Typography>
      </BoxWithLabel>

      <BoxWithLabel size="small" label={t('patients:phone')}>
        <Typography variant="body2">{patientProfile.phone}</Typography>
      </BoxWithLabel>
      <BoxWithLabel size="small" label={t('patients:address')}>
        <Typography variant="body2">
          {formatAddress(
            patientProfile.addressPostalCode,
            patientProfile.addressCity,
            patientProfile.addressStreet
          )}
        </Typography>
      </BoxWithLabel>

      <SendMessageToPatientButton patientProfile={patientProfile} />
    </Stack>
  )
}
